<h4 class="p-2 pl-4 mb-4 text-white" mat-dialog-title>&nbsp;{{data.title}}</h4>
<mat-dialog-content class="pb-2">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field fxFlex="1 1 auto">
            <mat-label>{{translate.getLng('SEARCH')}} {{translate.getLng('INVERTER')}}</mat-label>
            <input matInput [(ngModel)]="inverterSearchString" (input)="filterInverter($event)">
        </mat-form-field>
        <mat-icon>search</mat-icon>
    </div>
    <div class="p-2 mt-2" fxLayout="row" fxLayoutAlign="space-between center"
        *ngFor="let i of tempAllInverters | inverterFilter : inverterSearchString">
        <mat-checkbox [(ngModel)]="i.selected" (change)="selectedSubGen(i)" fxFlex="1 1 5%"></mat-checkbox>
        <div class="ml-3 text-left" fxFlex="1 1 auto">{{i.inverter.name}}<br>
            <span class="sen-fs10" *ngIf="i.times">{{translate.getLng('MIN')}} {{translate.getLng('MODULES')}}:
                {{i.inverter.minPanel}},
                {{translate.getLng('MAX')}} {{translate.getLng('MODULES')}}: {{i.inverter.maxPanel}},
                {{translate.getLng('MPPT')}}: {{i.inverter.mppt.length}},
                {{translate.getLng('ADD')}}: {{i?.totalPanels}} {{translate.getLng('MODULES')}}</span>
        </div>
        <mat-icon class="sen-fs12 mx-3" fxFlex="1 1 5%">clear</mat-icon>
        <mat-form-field class="sen-number-input font-weight-bold sen-fs16" fxFlex="1 1 15%">
            <input [(ngModel)]="i.times" [disabled]="!i.times" min="0" (input)="selectedSubGen(i)" type="number"
                class="text-right" matInput>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="text-center mt-4 justify-content-center">
    <button mat-raised-button class="px-5 py-2" (click)="closeDialogue()">{{data.buttons.cancel}}</button>
    <button mat-raised-button [disabled]="comboMissing" color="primary" class="px-5 py-2"
        (click)="closeDialogue(selectedGen)">{{data.buttons.add}}</button>
</mat-dialog-actions>